import { useMutation } from '@tanstack/react-query'

import { credencialLocal } from '@/features/biometria/services/credencialLocal'
import { revokePushSubscription } from '@/features/notificacoes/services/pushService'
import { queryClient } from '@/lib/queryClient'
import { useAuthStore } from '@/stores/authStore'

import { authApi } from '../api/authApi'
import type { LoginRequest } from '../types/authRequests'

/**
 * Autentica e guarda a sessão em memória. Envia o id da biometria guardado neste aparelho;
 * sem vínculo na resposta, o id não vale mais e o app oferece o cadastro.
 */
export function useLogin() {
  const setSession = useAuthStore((state) => state.setSession)
  const setOfertarBiometria = useAuthStore((state) => state.setOfertarBiometria)
  return useMutation({
    mutationFn: (body: LoginRequest) =>
      authApi.login({
        ...body,
        credencialBiometriaId: credencialLocal.obter(body.nomeUsuario),
      }),
    onSuccess: (session, body) => {
      setSession(session)
      if (session.biometriaVinculada === false) {
        credencialLocal.apagar(body.nomeUsuario)
        setOfertarBiometria(true)
      }
    },
  })
}

/**
 * Desvincula o push do aparelho (enquanto ainda há token), revoga o refresh
 * token no servidor e limpa o estado local (mesmo em falha).
 */
export function useLogout() {
  const clearSession = useAuthStore((state) => state.clearSession)
  return useMutation({
    mutationFn: async () => {
      await revokePushSubscription()
      await authApi.logout()
    },
    onSettled: () => {
      clearSession()
      queryClient.clear()
    },
  })
}

export function useForgotPassword() {
  return useMutation({ mutationFn: authApi.forgotPassword })
}

export function useResetPassword() {
  return useMutation({ mutationFn: authApi.resetPassword })
}
